import Vue from 'vue'
import moment from 'moment'
import _result from 'lodash/result'
import { Auth } from '../service/Auth'

moment.locale('pt')
Vue.prototype.moment = moment
Vue.prototype.$auth = Auth
Vue.prototype._ = {
  result: _result
}
